module.exports = __webpack_public_path__ + "img/fuckiso (18).6deaf035.jpg";